import { Component, ViewChild,Injectable  } from '@angular/core';
import {IonicPage, ModalController, NavController, NavParams} from 'ionic-angular';
import { Platform, MenuController, App} from 'ionic-angular';
import { ServiceProvider } from '../../providers/service/service';
import { Storage } from '@ionic/storage';
import { AlertController, Nav, ToastController, LoadingController } from 'ionic-angular';
import {EnquiryFormPage} from "../enquiry-form/enquiry-form";
import { SocialSharing } from '@ionic-native/social-sharing';
import {AddAppointmentPage} from "../add-appointment/add-appointment";
import {DomSanitizer} from "@angular/platform-browser";
import { WebIntent } from '@ionic-native/web-intent';
import {DataCallLogPage} from "../data-call-log/data-call-log";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {ListDataModelPage} from "../list-data-model/list-data-model";
import {Contacts, Contact, ContactName, ContactField  } from '@ionic-native/contacts';
import {FileTransfer,FileUploadOptions, FileTransferObject} from "@ionic-native/file-transfer";
import {File} from "@ionic-native/file";
import moment from 'moment';

@Component({
  selector: 'page-feedback',
  templateUrl: 'feedback.html',
})
export class FeedbackPage {

  SchoolData:any;
  FUserId:any;
  UserRights:any;
  School = 'All';
  FeedbackStatus ='Yes';
  FeedbackStatusData:any;

  FeedbackData:any;
  FeedbackData1:any;
  datanotfound:any;

  shownGroup:any;


  constructor(public navCtrl: NavController, public navParams: NavParams, public service: ServiceProvider, public platform:Platform, menuCtrl:MenuController, public loadingCtrl: LoadingController, public toastCtrl: ToastController,
              public storage: Storage,
              public _app: App,
              public modalCtrl: ModalController,public alertCtrl: AlertController,
              private contacts: Contacts,
              private sanitizer: DomSanitizer,
              private socialSharing: SocialSharing,
              public iab: InAppBrowser,
              private webIntent:WebIntent,
              public file:File) {
    this.platform.ready().then(() => {

      this.SchoolData = {
        "All": 0,
        "GWW": 2,
        "GWE": 3,
        "GEIS": 1
      };

      this.FeedbackStatusData = {
        "Yes": 1,
        "No": 2,
        "MayBe": 3,
        "AdmDone": 4
      };

      Promise.all([this.storage.get('LoginData')]).then(values => {
        this.FUserId = values[0]['FUserId'];
        console.log(this.FUserId);
        this.get_user_rights(this.FUserId);

      });
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FeedbackPage');
  }

  get_user_rights(FUserId) {
    this.service.httpcall('web_service/get_users_rights?FUserId=' + FUserId).subscribe(data => {
      console.log(data['RightsData']);
      this.UserRights = data['RightsData'];
      if (this.UserRights != undefined) {
        console.log(this.School);
        this.loadvalues(this.SchoolData[this.School], this.FUserId,this.FeedbackStatusData[this.FeedbackStatus]);
      }
    })
  }

  active_tab(tab) {
    console.log(tab);
    this.School = tab;
    this.loadvalues(this.SchoolData[this.School], this.FUserId,this.FeedbackStatusData[this.FeedbackStatus]);
    //get types for that particular school only [{Enquiry:true,Admission:false}]
  }

  active_status_tab(tab) {
    console.log(tab);
    this.FeedbackStatus = tab;
    console.log(this.FeedbackStatus+" "+this.FeedbackStatusData[this.FeedbackStatus]);
    this.loadvalues(this.SchoolData[this.School], this.FUserId,this.FeedbackStatusData[this.FeedbackStatus]);
    //get types for that particular school only [{Enquiry:true,Admission:false}]
  }

  loadvalues(FSchoolId, FUserId,FeedbackStatus){
    this.FeedbackData = [];
    this.datanotfound=null;
    console.log("FSchoolId", FSchoolId);
    this.service.httpcall('web_service/get_feedback?FSchoolId=' + FSchoolId + '&FUserId=' + FUserId+'&FeedbackStatus='+FeedbackStatus).subscribe(data => {
      // loading.dismiss();
      console.log(data);
      if(data['response']=="success"){
        this.datanotfound=null;

        this.FeedbackData1 = data['data'];
        this.FeedbackData = this.FeedbackData1;

        console.log(this.FeedbackData);
      }else{
        this.datanotfound=data['error_description'];
      }

    })
  }

  get_color(ans){
    if(ans=='Yes'){
      return 'green-color';
    }else if(ans=='No'){
      return 'red-color';
    }else if(ans=='May Be'){
      return 'yellow-color';
    }

  }

  get_management_color(ans){
    if(ans=='Yes'){
      return 'blue-color';
    }else if(ans=='No'){
      return 'brown-color';
    }else {
      return 'green-color1';
    }
  }

  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      this.shownGroup = null;
    } else {
      this.shownGroup = group;
    }
  }

  isGroupShown(group) {
    return this.shownGroup === group;
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues(this.SchoolData[this.School], this.FUserId,this.FeedbackStatusData[this.FeedbackStatus]);
    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  enquiry_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Call',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            // window.location.href = 'tel:'  + data;

            let loading = this.loadingCtrl.create({
              content: 'Loading',
              enableBackdropDismiss:false
            });
            loading.present();


            var formdata=new FormData();
            formdata.append("FWebEnquiryId", enquirydata.FWebEnquiryId);
            formdata.append("AddedBy",this.FUserId);
            formdata.append("CallTo",data);
            formdata.append("CallType","2");
            formdata.append("FileName","text");
            // formdata.append("CallFor",this.CallFor);


            this.service.httppostFormcall('web_service/add_enquiry_call_logs', formdata).subscribe(resdata => {
              console.log(resdata);
              if (resdata['response'] == 'success') {
                var LogId=resdata['LogId'];
                if(loading)
                  loading.dismiss();
                loading = undefined;
                var link="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+data+"?/&apn=com.example.callrecording";
                const browser = this.iab.create(link,'_system',{location:'no'});
                window.location.href="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+data+"?/&apn=com.example.callrecording";
              } else {
                if(loading)
                  loading.dismiss();
                loading = undefined;
              }
            },(err)=>{
              if(loading)
                loading.dismiss();
              loading = undefined;
            });

          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.FatherContact,
      value: enquirydata.FatherContact
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.MotherContact,
      value: enquirydata.MotherContact
    })
    myAlert.present();
  }
  go_to_call_logs(item){
    let Call_logs_model = this.modalCtrl.create(DataCallLogPage,{data:item,Tab:4});
    // AppointmentModel.onDidDismiss(data => {
    //   console.log(data);
    // });
    Call_logs_model.present();
  }
  whatsapp_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Whatsapp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'whatsapp://send?phone=+91' + data;
          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: enquirydata.FatherContact,
      value: enquirydata.FatherContact
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.MotherContact,
      value: enquirydata.MotherContact
    })
    myAlert.present();


  }
  msg_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Message',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'sms:'  + data;
          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.FatherContact,
      value: enquirydata.FatherContact
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.MotherContact,
      value: enquirydata.MotherContact
    })
    myAlert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/feedback/feedback.ts